import React from 'react';
import { useFormik } from 'formik';
import { login } from '../api/login';
import * as Yup from 'yup';
import { ValidationMessage } from '../../Helpers/validation/validationMessage';
import { setLoggedInUser } from '../reducers/loginState';
import { setCurrentPage } from '../../Navigation/currentPage';
import { SCR_COMPETITION } from '../../enums';
import { getLabel } from '../../Language/labels';
import { get } from 'lodash';
import { recaptchaValidate } from '../api/recaptchaValidate';
import { useState } from 'react';

const getInitialValues = () => {
  if (window.location.host === 'localhost:3000') {
    return {
       login_email: 'email4@example.com',
       login_password: '12345678abC@'
      //  login_email: '',
      //  login_password: ''
    }
  }else{
    return {
      login_email: '',
      login_password: ''
    }
  }
}

export const LoginForm = ({dispatch}) => {

  const [processing, setProcessing] = useState(false);

  const loginSchema = Yup.object().shape({
    login_email: Yup.string().email(getLabel('emailNotValid')).required(getLabel('emailRequired')),
    login_password: Yup.string().required(getLabel('passwordRequired'))
  });

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema: loginSchema,
    onSubmit: async function (values, { setFieldError }) {
      setProcessing(true);
      //get the recaptcha token
      const recaptchaResult = await recaptchaValidate();
      
      let result = await login(values, recaptchaResult).catch(({response}) => {
        const {data: {description, message}} = response;
        setFieldError('login_email', (description || message));
        setFieldError('login_password', (description || message));
      });

      if (get(result, 'data.data.id', 0) > 0) {
        //set logged in user
        dispatch(setLoggedInUser({...result.data.data, token: result.token}));
        //navigate to overview
        dispatch(setCurrentPage(SCR_COMPETITION));
      }

      setProcessing(false);

    }
  })

  return (
    <div className='login-form-container'>
      <div className='login-form-title'>
        <h1 className='text-4xl'>{getLabel('loginTitle')}</h1>
      </div>
      <form className='form login-form' onSubmit={formik.handleSubmit}>

        <label className='form-control' htmlFor="login_email">
          <span>{getLabel('email')}</span>
          <input type="text" id="login_email" required
            onChange={formik.handleChange}
            value={formik.values.login_email} />
          <ValidationMessage error={formik.errors.login_email} touched={formik.touched.login_email} />
        </label>

        <label className='form-control' htmlFor="login_password">
          <span>{getLabel('password')}</span>
          <input type="password" id="login_password" required
            onChange={formik.handleChange}
            value={formik.values.login_password} />
          <ValidationMessage error={formik.errors.login_password} touched={formik.touched.login_password} />
        </label>

        <input type="hidden" id="recaptcha_token_login" />

        <div className='form-control login-form-submit'>
          {!processing && <button className='form-submit' type="submit">{getLabel('loginButton')}</button>}
          {processing && <div className='form-submit'>{getLabel('loginButton')}</div>}
        </div>

        <a className='underline underline-offset-4 my-4' target="_blank" rel="noreferrer" href="https://users.worldphoto.org/user/password">Reset password</a>
      </form>
    </div>
  )
}